import React, { useState, useEffect, useCallback } from 'react'
import { Button } from 'syngenta-react-components'
import { getSalesYear, patchSalesYear, postPlantingHarvestDate, patchPlantingHarvestDate, getAllPlantingHarvestDate } from '../../services/apiHelper'
import { generateYearsOptions } from '../../services/utils'

const DefaultSalesYearFrom = ( { handleClose }) => {
  const [loading, setLoading] = useState(true)
  const [salesYear, setSalesYear] = useState('')
  const [selectedSalesYear, setSelectedSalesYear] = useState('')
  const [plantingDate, setPlantingDate] = useState('')
  const [harvestDate, setHarvestDate] = useState('')
  const [allPlantingHarvestDate, setAllPlantingHarvestDate] = useState([])

  const convertTimestampToDate = timestamp => {
    const dateObject = new Date(timestamp)
    const year = dateObject.getUTCFullYear()
    const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, '0')
    const day = dateObject.getUTCDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const setDates =  useCallback((pantingDate, harvestDate) => {
    setPlantingDate(convertTimestampToDate(new Date(pantingDate)))
    setHarvestDate(convertTimestampToDate(new Date(harvestDate)))
  },[])

  useEffect(()=>{
    const retrieveSalesYear = async () => {
      await getAllPlantingHarvestDate().then(datesData=>{
        setAllPlantingHarvestDate(datesData.data)
      })
      await getSalesYear().then(sales_year=>{
        setSalesYear(sales_year.data.sales_year)
      })
      setLoading(false)
    }
    retrieveSalesYear()
  },[])

  useEffect(()=>{
    if(selectedSalesYear || salesYear) {
      const yearValue = (selectedSalesYear ? selectedSalesYear : salesYear)
      const findDate = allPlantingHarvestDate.find(data=>data.selected_year === yearValue)
      if(allPlantingHarvestDate.length > 0 && findDate) {
        setDates(findDate.planting_date, findDate.harvest_date)
      } else {
        setDates(yearValue+'-06-15', yearValue+'-11-15')
      }
    }
  },[selectedSalesYear, salesYear, allPlantingHarvestDate, setDates])

  const handleDateChange = (dateVal, fieldName) => {
    if(fieldName === 'plantingDate') {
      setPlantingDate(dateVal.target.value)
    } else {
      setHarvestDate(dateVal.target.value)
    }
  }

  const generateSalesYearRadioButtons = () => {
    const salesYearMinusOne = (parseInt(salesYear) - 2).toString()
    const yearOptions = generateYearsOptions(salesYearMinusOne, 5)
    return(
      <div className='h200 p25 mb10 df fxdrc cfs fzs16'>
        {yearOptions.map((year, index) => {
          const yearValue = year.value.toString()  
          const isSelected = yearValue === (selectedSalesYear ? selectedSalesYear : salesYear)
          return(
            <label className="df dxfrr mb10 aic" key={index}>
              <span className='mr5'>
                <input
                  style={{ height: '15px', width: '15px' }}
                  className="fz16"
                  type="radio"
                  value={yearValue}
                  checked={isSelected}
                  onChange={() => setSelectedSalesYear(yearValue)}
                />
              </span>
              <span className='mt-5 pt2'>{yearValue}</span>
            </label>
          )
        })}
      </div>
    )
  }

  const generateDateSections = fieldName => {
    return (
      <div className='pl25 pr25 pb25 w45%'>
        <div className='mb5 fz15 fw600 w100%'>
          {fieldName === 'plantingDate'? 'Planting' : 'Harvest'} Stewardship Date
        </div>
        <input
          className="bd2-s-input mt4  fz15 w235"
          type="date"
          id={fieldName}
          name={fieldName}
          value={fieldName === 'plantingDate'? plantingDate : harvestDate}
          onChange={e => handleDateChange(e,fieldName)}
        />
      </div>)
  }

  const submitHandler = async () => {
    setLoading(true)
    const yearValue = (selectedSalesYear ? selectedSalesYear : salesYear)
    let plantingHarvestData = {
      selected_year: yearValue,
      planting_date: plantingDate,
      harvest_date: harvestDate
    }
    patchSalesYear(yearValue)
    const findDate = allPlantingHarvestDate.find(data=>data.selected_year === yearValue)
    if(findDate) {
      plantingHarvestData = {
        ...plantingHarvestData,
        planting_and_harvest_date_id: findDate.planting_and_harvest_date_id
      }
      await patchPlantingHarvestDate(plantingHarvestData, findDate.planting_and_harvest_date_id)
    } else {
      await postPlantingHarvestDate(plantingHarvestData)
    }
    setLoading(false)
    handleClose()
  }

  return(
    <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
      <div className='bb1-s-lightgray df jcsb'>
        <div className='df ml15 mt15 mb15'>
          <div className='fw600 ml10'>
           Set default sales year
          </div>
        </div>
      </div>
      {loading ? <div className="df aic jcc h175"> <div className='loader h80 w80'/> </div>  : 
        <>  
          { generateSalesYearRadioButtons() }
          { generateDateSections('plantingDate') }
          { generateDateSections('harvestDate') }
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Cancel' onClick={() => handleClose()}/>
              <Button 
                customClassName='miw70' 
                type='success' 
                text='Ok' 
                onClick={submitHandler}
              />
            </div>
          </div>
        </>
      }
    </div>
  )
}

export default DefaultSalesYearFrom